<template>
  <div class="content-body">
    <div class="d-flex justify-content-between align-items-center w-100 mb-2">
      <h2 class="content-header-title" style="border-right: none;">Генерация протоколов</h2>
      <!-- <div>
        <button class="compose btn btn-primary" @click="newRecord()">Загрузить справочники</button>
      </div> -->
    </div>

    <section class="modern-horizontal-wizard">
      <div class="bs-stepper wizard-modern">
        <div class="bs-stepper-header pt-0 px-0" style="flex-wrap: nowrap;">
          <div class="d-flex align-items-center" v-for="(st, key) in steps" >
            <div class="step" :class="{ 'active': step == st.id}">
              <button type="button" class="step-trigger" @click="changeTab(st.id)">
                <span class="bs-stepper-box">
                  {{st.id}}
                </span>
                <span class="bs-stepper-label mt-0" style="white-space: normal!important;">
                  <span class="bs-stepper-title">{{st.name}}</span>
                </span>
              </button>
            </div>
            <div class="line" v-if="steps.length != key + 1">
              <font-awesome-icon icon="fa-solid fa-angle-right" />
            </div>
          </div>
        </div>
        <div class="bs-stepper-content p-0" style="background:unset;border:unset;box-shadow:unset;">
          <div id="contest-step-1" class="content" :class="{ 'active': step == 1}">
            <p><b>Сначала АИДУ, потом Скановал</b></p>
            <div class="d-flex mb-2">
              <button class="compose btn btn-success" style="position: relative; overflow: hidden;">
                Анализировать АИДУ
                <input type="file" :key="fileInputKey" @change="fileUpload" accept=".htm"  class="form-control" style="position: absolute;top: 0;right: 0;min-width: 100%;min-height: 100%;filter: alpha(opacity=0);opacity: 0;outline: none;cursor: inherit;display: block;"  />
              </button>
              <button class="ml-2 compose btn btn-warning" style="position: relative; overflow: hidden;">
                Анализировать Скановал
                <input type="file" :key="fileInputKeyS" @change="fileUploadS" accept=".html"  class="form-control" style="position: absolute;top: 0;right: 0;min-width: 100%;min-height: 100%;filter: alpha(opacity=0);opacity: 0;outline: none;cursor: inherit;display: block;"  />
              </button>

            </div>
            <div class="blog-list-wrapper" v-if="scanovalData.number">
              <div class="card h-100">
                <div class="card-body">
                  <h5 class="card-title">Данные из Скановал`а:</h5>
                  <p><b>№ отчета:</b> {{scanovalData.number}}</p>
                  <p><b>Начало / Завершение сканирования:</b> {{getDateTime(scanovalData.start_at)}} / {{getDateTime(scanovalData.end_at)}}</p>
                  <p><b>Формирование отчета:</b> {{getDateTime(scanovalData.formed_at)}}</p>
                  <p v-if="scanovalData.vulnerabilities">
                    <b>Уязвимости:</b>
                    <ul>
                      <li v-for="vulnerability in scanovalData.vulnerabilities"><b>{{vulnerability.name}}:</b> {{vulnerability.find}} из {{vulnerability.total}}</li>
                    </ul>
                  </p>
                </div>
              </div>
            </div>

            <div class="blog-list-wrapper" v-if="parsedData.computer_name">
              <div class="card h-100">
                <div class="card-body">
                  <h5 class="card-title">Данные из Aida64:</h5>
                  <div class="row">
                    <div class="col-6">
                      <p><b>Дата снятия отчёта:</b> {{getDateTime(parsedData.created_at)}}</p>
                      <p><b>Имя компьютера:</b> {{parsedData.computer_name}}</p>

                      <p><b>IP адрес:</b> {{parsedData.ip_adress}}</p>
                      <p><b>MAC адрес:</b> {{parsedData.mac_adress}}</p>
                      <p><b>Оптический накопитель (дисковод):</b>
                        <template v-if="parsedData.optical_reader">
                          Да ({{parsedData.optical_reader}})
                        </template>
                        <template v-else>
                          Нет
                        </template>
                      </p>
                      <p>
                        <b>Принтеры:</b>
                        <template v-if="parsedData.printers && parsedData.printers.length > 0">
                          <ul>
                            <li v-for="printer in parsedData.printers">{{printer.name}} (Порт {{printer.port}})</li>
                          </ul>
                        </template>
                        <template v-else>
                          Нет
                        </template>
                      </p>
                    </div>
                    <div class="col-6">
                      <p v-if="parsedData.computer_manufacture">
                        <b>DMI:</b>
                        <ul>
                          <li>Производитель: {{parsedData.computer_manufacture}}</li>
                          <li>Система: {{parsedData.computer_system}}</li>
                          <li>Версия: {{parsedData.computer_system_version}}</li>
                          <li>Серийный номер: {{parsedData.computer_sn}}</li>
                        </ul>
                      </p>
                      <p>
                        <b>Windows:</b>
                        <ul>
                          <li>Дата установки: {{parsedData.windows_install}}</li>
                          <li>Версия ОС: {{parsedData.windows_build}}</li>
                          <li>Человеческая версия: {{parsedData.human_os}}</li>
                          <li>Человеческий билд: {{parsedData.human_build}}</li>
                        </ul>
                      </p>
                      <p>
                        <b>Диски:</b>
                        <ul v-if="orderedDisks.length > 0">
                          <li v-for="disk in orderedDisks"><b>{{disk.letter}}:</b> {{disk.value}}</li>
                        </ul>
                      </p>
                    </div>
                    <div class="col-12">
                      <div class="w-100">
                        <b>Обработка ПО:</b>
                        <p>
                          <template v-for="(program, key) in filteredPrograms3">
                            «{{program}}»<template v-if="key+1 !== filteredPrograms3.length">, </template>
                          </template>
                        </p>

                        <b>Специальное ПО (ПО для ввода):</b>
                        <p>
                          <template v-for="(program, key) in filteredPrograms4">
                            «{{program}}»<template v-if="key+1 !== filteredPrograms4.length">, </template>
                          </template>
                        </p>

                        <b>Хранение ПО:</b>
                        <p>
                          <template v-for="(program, key) in filteredPrograms5">
                            «{{program}}»<template v-if="key+1 !== filteredPrograms5.length">, </template>
                          </template>
                        </p>

                        <b>Печать ПО:</b>
                        <p>
                          <template v-for="(program, key) in filteredPrograms6">
                            «{{program}}»<template v-if="key+1 !== filteredPrograms6.length">, </template>
                          </template>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <div class="d-flex flex-row align-items-center mr-2">
                    <label class="mr-2 mb-0">Подробный отчёт</label>
                    <div class="custom-control custom-switch custom-switch-primary">
                      <input type="checkbox" class="custom-control-input" id="showMore" v-model="showMore" />
                      <label class="custom-control-label" for="showMore">
                        <span class="switch-icon-left"><i data-feather="check"></i></span>
                        <span class="switch-icon-right"><i data-feather="x"></i></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card h-100" v-show="showMore">
                <div class="card-body p-0">
                  <h5 class="card-title mb-1 pl-2 pt-2 d-flex justify-content-between">
                    Список пользователей:
                    <div class="d-flex flex-row align-items-center mr-2">
                      <label class="mr-2 mb-0">Скрыть встроенные</label>
                      <div class="custom-control custom-switch custom-switch-primary">
                        <input type="checkbox" class="custom-control-input" id="zapret_hide" v-model="zapret_hide" />
                        <label class="custom-control-label" for="zapret_hide">
                          <span class="switch-icon-left"><i data-feather="check"></i></span>
                          <span class="switch-icon-right"><i data-feather="x"></i></span>
                        </label>
                      </div>
                    </div>
                  </h5>
                  <table class="table" v-if="filteredUsers.length > 0">
                    <thead>
                      <tr>
                        <th scope="col">Имя пользователя</th>
                        <th scope="col">Запрет учётной записи</th>
                        <th scope="col">Число входов в систему</th>
                        <th scope="col">Комментарий</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="user in filteredUsers">
                        <td>{{user.name}}</td>
                        <td>{{user.zapret}}</td>
                        <td>{{user.login_count}}</td>
                        <td>{{user.type}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="card h-100" v-if="parsedData.licenses && parsedData.licenses.length > 0" v-show="showMore">
                <div class="card-body p-0">
                  <h5 class="card-title mb-1 pl-2 pt-2">
                    Лицензии:
                  </h5>
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Наименование</th>
                        <th scope="col">Ключ продукта</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(license, key) in parsedData.licenses">
                        <td>{{key + 1}}</td>
                        <td>{{license.name}}</td>
                        <td>
                          <template v-if="license.key">
                            {{license.key}}
                          </template>
                          <template v-else>
                            -
                          </template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <template v-if="filteredPrograms2.length > 0 && showMore">
                <div class="d-flex justify-content-start mb-0 w-100">
                  <div class="btn-group">
                    <a @click.prevent="changeFilter('all')" href="#" class="btn" :class="filter == 'all' ? 'btn-success' : 'btn-primary'" style="border-bottom-left-radius: 0;">Все ({{all_count}})</a>
                    <a @click.prevent="changeFilter('skzi')" href="#" class="btn" :class="filter == 'skzi' ? 'btn-success' : 'btn-primary'">СКЗИ ({{skzi_count}})</a>
                    <a @click.prevent="changeFilter('szi')" href="#" class="btn" :class="filter == 'szi' ? 'btn-success' : 'btn-primary'">СЗИ ({{szi_count}})</a>
                    <a @click.prevent="changeFilter('browser')" href="#" class="btn" :class="filter == 'browser' ? 'btn-success' : 'btn-primary'" style="border-bottom-right-radius: 0;">Браузеры ({{browser_count}})</a>
                  </div>
                </div>
                <div class="card h-100">
                  <div class="card-body p-0">
                    <h5 class="card-title mb-1 pl-2 pt-2 d-flex justify-content-between">
                      Список программ:
                      <div class="d-flex">
                        <div class="d-flex flex-row align-items-center mr-2">
                          <label class="mr-2 mb-0">Таблица для заключения об эксплуатации СКЗИ (Крипто Про)</label>
                          <div class="custom-control custom-switch custom-switch-primary">
                            <input type="checkbox" class="custom-control-input" id="show_conclusion_scsi_table_cryptopro" v-on:change="transform_for_conclusion_scsi_table('КриптоПро')" v-model="show_conclusion_scsi_table_cryptopro"/>
                            <label class="custom-control-label" for="show_conclusion_scsi_table_cryptopro">
                              <span class="switch-icon-left"><i data-feather="check"></i></span>
                              <span class="switch-icon-right"><i data-feather="x"></i></span>
                            </label>
                          </div>
                        </div>
                        <div class="d-flex flex-row align-items-center mr-2">
                          <label class="mr-2 mb-0">Таблица для заключения об эксплуатации СКЗИ (ViPNet )</label>
                          <div class="custom-control custom-switch custom-switch-primary">
                            <input type="checkbox" class="custom-control-input" id="show_conclusion_scsi_table_vipnet" v-on:change="transform_for_conclusion_scsi_table('ViPNet')" v-model="show_conclusion_scsi_table_vipnet"/>
                            <label class="custom-control-label" for="show_conclusion_scsi_table_vipnet">
                              <span class="switch-icon-left"><i data-feather="check"></i></span>
                              <span class="switch-icon-right"><i data-feather="x"></i></span>
                            </label>
                          </div>
                        </div>
                        <div class="d-flex flex-row align-items-center mr-2">
                          <label class="mr-2 mb-0">Таблица для Формуляра</label>
                          <div class="custom-control custom-switch custom-switch-primary">
                            <input type="checkbox" class="custom-control-input" id="show_formulary_table" v-on:change="transform_for_formulary_table()" v-model="show_formulary_table"/>
                            <label class="custom-control-label" for="show_formulary_table">
                              <span class="switch-icon-left"><i data-feather="check"></i></span>
                              <span class="switch-icon-right"><i data-feather="x"></i></span>
                            </label>
                          </div>
                        </div>
                        <div class="d-flex flex-row align-items-center mr-2">
                          <label class="mr-2 mb-0">Скрыть СКЗИ</label>
                          <div class="custom-control custom-switch custom-switch-primary">
                            <input type="checkbox" class="custom-control-input" id="hide_skzi" v-on:change="checkFilter()" v-model="hide_skzi" :disabled="disableHideScsi" />
                            <label class="custom-control-label" for="hide_skzi">
                              <span class="switch-icon-left"><i data-feather="check"></i></span>
                              <span class="switch-icon-right"><i data-feather="x"></i></span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </h5>
                    <div class="table-striped">
                      <table class="table">
                        <thead>
                        <tr>
                          <th v-for="col_name in program_table_cols" scope="col">{{col_name}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(program, key) in filteredPrograms2">
                          <td v-if="program_table_cols.id">{{key + 1}}</td>
                          <td v-if="program_table_cols.name">{{program.name}}</td>
                          <td v-if="program_table_cols.version">
                            <template v-if="program.version">
                              {{program.version}}
                            </template>
                            <template v-else>
                              -
                            </template>
                          </td>
                          <td v-if="program_table_cols.publisher">
                            <template v-if="program.razrab">
                              {{program.razrab}}
                            </template>
                            <template v-else>
                              -
                            </template>
                          </td>
                          <td v-if="program_table_cols.part_num">
                            <template v-if="program.key">
                              {{program.key}}
                            </template>
                            <template v-else>
                              -
                            </template>
                          </td>
                          <td v-if="program_table_cols.cert_info">
                            <template>
                              -
                            </template>
                          </td>
                          <td v-if="program_table_cols.installation_date">{{getDate(program.date)}}</td>
                          <td v-if="program_table_cols.tags">
                            <ul v-if="program.tags && program.tags.length > 0">
                              <li v-for="tag in program.tags">{{tag}}</li>
                            </ul>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </template>
            </div>

            <div class="d-flex justify-content-end">
              <button type="button" class="btn btn-success btn-next" @click.prevent="nextStep()">
                <span class="align-middle d-sm-inline-block d-none">Следующий шаг</span>
                <font-awesome-icon icon="fas fa-arrow-right" />
              </button>
            </div>
          </div>
          <div id="contest-step-2" class="content" :class="{ 'active': step == 2}">
            <div class="row" v-if="!isUpdating2">
              <div :class="'col-'+ (12 / categories.length)" v-for="category in categories">
                <div class="card">
                  <div class="card-header" style="background-color: rgba(34, 41, 47, 0.03);border-bottom: 1px solid rgba(34, 41, 47, 0.125)">
                    {{category.name}}:
                  </div>
                  <div class="card-body p-0">
                    <ul class="list-group list-group-flush" v-if="templates && templates[category.id]">
                      <li class="list-group-item">
                        <div class="form-check" v-for="template in templates[category.id]">
                          <input class="form-check-input" type="checkbox" name="flexRadioDefault" :id="'check_'+template.id" @change="updateCategory(category.id, template.id)" v-model="selectedTemplate.checks[category.id][template.id]">
                          <label class="form-check-label" :for="'check_'+template.id">
                            {{template.po}} ({{template.version}})
                          </label>
                          <p class="mb-0"><small>{{template.description}}</small></p>
                          <input v-if="selectedTemplate.checks[category.id][template.id]" type="text" placeholder="Порядковый номер" class="form-control form-control-sm" v-model="template.orderKey">
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-between">
              <button type="button" class="btn btn-primary btn-prev" @click.prevent="prevStep()">
                <font-awesome-icon icon="fas fa-arrow-left" />
                <span class="align-middle d-sm-inline-block d-none">Предыдущий шаг</span>
              </button>
              <button type="button" class="btn btn-success btn-next" @click.prevent="nextStep()">
                <span class="align-middle d-sm-inline-block d-none">Следующий шаг</span>
                <font-awesome-icon icon="fas fa-arrow-right" />
              </button>
            </div>
          </div>
          <div id="contest-step-3" class="content" :class="{ 'active': step == 3}">
            <div class="row" v-if="!isUpdating">
              <div class="col-12">
                <div class="form-group" v-for="def in defaultFields">
                  <label>{{def.name}}</label>
                  <input type="text" v-model="def.value" :placeholder="def.name" class="form-control">
                </div>
              </div>
              <div class="col-12">
                <div class="card">
                  <div class="card-header d-flex justify-content-end pb-0">
                    <button class="compose btn btn-success" @click="updateData()">Обновить данные</button>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-6">
                        <div class="mb-1">
                          <p class="mb-0"><b>Время отсчёта отчётов</b></p>
                          <p class="mb-0">
                            <date-picker v-model="startTime" type="datetime" :confirm="true" value-type="format" :show-time-header="true" format="DD.MM.YYYY H:mm:ss"></date-picker>
                          </p>
                        </div>
                        <div>
                          <p class="mb-0"><b>Буква DVD привода (внешнего мб)</b></p>
                          <input type="text" placeholder="Буква Диска" class="form-control" v-model="dvd_letter">
                        </div>

                        <p><b>ДатаиВремяДистр:</b> в формате 11-10-2024 9:35:17</p>
                      </div>
                      <div class="col-6">
                        <div class="d-flex flex-row align-items-center mr-2">
                          <p class="mr-2 mb-0"><b>Нужны протоколы затирания</b></p>
                          <div class="custom-control custom-switch custom-switch-primary">
                            <input type="checkbox" class="custom-control-input" id="needProtocolCleaning" v-model="needProtocolCleaning" v-on:change="updateProtocolCleaning()" />
                            <label class="custom-control-label" for="needProtocolCleaning">
                              <span class="switch-icon-left"><i data-feather="check"></i></span>
                              <span class="switch-icon-right"><i data-feather="x"></i></span>
                            </label>
                          </div>
                        </div>

                        <div class="row" v-if="needProtocolCleaning && cleaning_id">
                          <div class="col" v-for="(template, template_key) in selectedTemplate.fields[cleaning_id]" v-if="template && template.length > 0">
                            <div class="form-floating mt-1" v-for="(input, key) in template">
                              <label class="form-label">{{input.name}}</label>
                              <input type="text" :placeholder="input.name" class="form-control" v-model="input.value">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div :class="'col-'+ (12 / categories.length)" v-for="category in categories">
                <div class="card">
                  <div class="card-header" style="background-color: rgba(34, 41, 47, 0.03);border-bottom: 1px solid rgba(34, 41, 47, 0.125)">
                    {{category.name}}:
                  </div>
                  <div class="card-body p-0" v-if="selectedTemplate.fields[category.id] && selectedTemplate.fields[category.id].length > 0">
                    <template v-for="(template, template_key) in selectedTemplate.fields[category.id]">
                      <div v-if="template && template.length > 0">
                        <h5 class="card-title pl-1 pt-1">{{getTemplateName(category.id, template_key)}}</h5>
                        <div class="form-floating mt-2" v-for="(input, key) in template">
                          <input type="text" :placeholder="input.name" class="form-control" v-model="input.value">
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-between">
              <button type="button" class="btn btn-primary btn-prev" @click.prevent="prevStep()">
                <font-awesome-icon icon="fas fa-arrow-left" />
                <span class="align-middle d-sm-inline-block d-none">Предыдущий шаг</span>
              </button>
              <button type="button" class="btn btn-success btn-next" @click.prevent="createProtocols()">
                <span class="align-middle d-sm-inline-block d-none">Создать протоколы</span>
                <font-awesome-icon icon="fas fa-arrow-right" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import moment from "moment";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ru';
import { uuid } from 'vue-uuid';

  export default {
    components: { DatePicker },
    computed: {
      filteredUsers(){
        if(this.zapret_hide && this.parsedData.users.length > 0){
          let output = [];
          this.parsedData.users.forEach(item => {
            if(item.zapret == 'Нет')
              output.push(item);
          });
          return output;
        }
        return this.parsedData.users;
      },
      filteredPrograms3(){
        let output = [];

        this.filteredPrograms.forEach(item => {
          if(item.tags && item.tags.length > 0 && item.tags.includes('OBRABOTKA_PO') && !output.includes(item.alt_name))
            output.push(item.alt_name)
        });

        return output;
      },
      filteredPrograms4(){
        let output = [];

        this.filteredPrograms.forEach(item => {
          if(item.tags && item.tags.length > 0 && item.tags.includes('SPECIAL_PO') && !output.includes(item.alt_name))
            output.push(item.alt_name)
        });

        return output;
      },
      filteredPrograms5(){
        let output = [];

        this.filteredPrograms.forEach(item => {
          if(item.tags && item.tags.length > 0 && item.tags.includes('XRANENIE_PO') && !output.includes(item.alt_name))
            output.push(item.alt_name)
        });

        return output;
      },
      filteredPrograms6(){
        let output = [];

        this.filteredPrograms.forEach(item => {
          if(item.tags && item.tags.length > 0 && item.tags.includes('PECHAT_PO') && !output.includes(item.alt_name))
            output.push(item.alt_name)
        });

        return output;
      },
      filteredPrograms2(){
        let output = [];

        if(this.show_conclusion_scsi_table_cryptopro || this.show_conclusion_scsi_table_vipnet || this.show_formulary_table){
          this.parsedData.licenses.forEach((item) => {
            if(item.name.includes('Windows')) {
              output.unshift({
                name: item.name,
                key: item.key,
                date: this.parsedData.windows_install,
              })
            }
            else if(item.name.includes('Internet Explorer')) {
              let date = null;
              this.parsedData.programs.forEach(program_item => {
                if(program_item.name.includes('Internet Explorer')) {
                  date = program_item.date;
                }
              });
              output.push({
                name: 'Microsoft Internet Explorer',
                key: item.key,
                date: date,
              })
            }
          })
        }

        if(this.show_formulary_table) {
          this.parsedData.programs.forEach(item => {
            if(item.tags.includes('OBRABOTKA_PO') && !item.name.includes('Internet Explorer')) {
              output.push({
                name: item.name,
                date: item.date,
              })
            }
          });
        }
        else if(this.show_conclusion_scsi_table_cryptopro || this.show_conclusion_scsi_table_vipnet) {
          this.filteredPrograms.forEach(item => {
            if(!item.name.includes(this.hide_scsi_type) && !item.name.includes('Internet Explorer'))
              output.push(item)
          });
        }
        else if(this.hide_skzi){
          this.filteredPrograms.forEach(item => {
            if(item.type !== 'skzi')
              output.push(item)
          });
        }else{
          output = this.filteredPrograms;
        }

        return output;
      },
      filteredPrograms(){
        if(this.filter == 'browser')
          return this.parsedData.programs.filter((item) => item.type == 'browser');
        else if(this.filter == 'skzi')
          return this.parsedData.programs.filter((item) => item.type == 'skzi');
        else if(this.filter == 'szi')
          return this.parsedData.programs.filter((item) => item.type == 'szi');
        else
          return this.parsedData.programs;
      },
      browser_count(){
        return this.parsedData.programs.filter((item) => item.type == 'browser').length;
      },
      skzi_count(){
        return this.parsedData.programs.filter((item) => item.type == 'skzi').length;
      },
      szi_count(){
        return this.parsedData.programs.filter((item) => item.type == 'szi').length;
      },
      all_count(){
        return this.parsedData.programs.length;
      },
      orderedDisks(){
        let output = [];
        if(this.parsedData.disks && this.parsedData.disks.length > 0)
        {
          let ideal_list = JSON.parse(JSON.stringify(this.disks));
          this.parsedData.disks.forEach(disk => {
            var index = ideal_list.indexOf(disk.letter);
            if(index !== -1)
              ideal_list.splice(index, 1);
            output.push(disk)
          });
          if(this.parsedData.optical_reader)
          {
            output.push({ letter: ideal_list[0], value: 'DVD привод'});
            this.dvd_letter = ideal_list[0] + ':';
            ideal_list.splice(0, 1);
          }
          else
          {
            output.push({ letter: ideal_list[0], value: 'Внешний DVD привод'});
            this.dvd_letter = ideal_list[0] + ':';
            ideal_list.splice(0, 1);
          }
        }
        return output.sort((a,b) => (a.letter > b.letter) ? 1 : ((b.letter > a.letter) ? -1 : 0));
      },
    },
    data () {
      return {
        uuid: uuid.v1(),
        steps: [
          { id: 1, name: 'Анализ первичных данных' },
          { id: 2, name: 'Выбор шаблонов' },
          { id: 3, name: 'Ввод информации' }
        ],
        disks: [
          'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
        ],
        dvd_letter: null,
        step: 1,
        startTime: null,
        startTimeByDate: [],
        needProtocolCleaning: false,
        categories: [],
        isUpdating: false,
        isUpdating2: false,
        cleaning_id: null,
        templates: [],
        showMore: false,
        filter: 'all',
        hide_skzi: false,
        hide_scsi_type: null,
        disableHideScsi: false,
        program_table_cols: {
          id: '#',
          name: 'Наименование',
          version: 'Версия',
          publisher: 'Издатель',
          installation_date: 'Дата установки',
          tags: 'Теги',
        },
        show_formulary_table: false,
        show_conclusion_scsi_table_vipnet: false,
        show_conclusion_scsi_table_cryptopro: false,
        zapret_hide: true,
        fileInputKey: 0,
        fileInputKeyS: 0,
        selectedTemplate: new Form({
          checks: [],
          fields: [],
          order: []
        }),
        defaultFields: [
          { name: "НазваниеПроекта", value: "Аттестация"},
          { name: "НазваниеОрганизации", value: "АРМ 1"},
          { name: "ДанныеЛицензииСканерВС", value: 'ООО "УПРАВЛЕНИЕ ИНФОРМАЦИОННОЙ БЕЗОПАСНОСТИ" №ЭФ2204-191237. Срок действия лицензии с 25.10.2024 до 03.11.2025'},
        ],
        parsedData: {
          computer_manufacture: null,
          computer_system: null,
          computer_system_version: null,
          computer_sn: null,
          computer_name: null,
          optical_reader: null,
          created_at: null,
          human_build: null,
          human_os: null,
          ip_adress: null,
          mac_adress: null,
          printers: [],
          programs: [],
          users: [],
          disks: [],
          licenses: [],
          windows_build: null,
          windows_install: null,
          random1: 0,
        },
        scanovalData: {
          number: null,
          start_at: null,
          end_at: null,
          formed_at: null,
          vulnerabilities: []
        }
      }
    },
    methods: {
      updateData(){
        this.isUpdating = true;
        this.selectedTemplate.fields.forEach((category_group, category_id) => {
          if(category_group && category_group.length > 0){
            category_group.forEach((template_group, template_id) => {
              if(template_group && template_group.length > 0){
                let template = null;

                if(this.templates[category_id]) {
                  template = this.templates[category_id].find(item => item.id == template_id);
                }
                const hasDateTimeField = template_group.some(field => field.name === 'ДатаиВремяОтчёт');

                if (!hasDateTimeField && template) {
                  template_group.push({
                    name: 'ДатаиВремяОтчёт',
                    value: null
                  });
                }

                template_group.forEach((field, field_key) => {
                  if(!this.defaultFields.filter((item) => item.name == field.name).length)
                  {
                    if(field.name == 'Каталог')
                    {
                      if(this.dvd_letter)
                        field.value = this.dvd_letter;
                    }
                    else if(field.name == 'ВладелецЛицензииСканерВС')
                    {
                      field.value = 'ООО "УПРАВЛЕНИЕ ИНФОРМАЦИОННОЙ БЕЗОПАСНОСТИ"';
                    }
                    else if(field.name == 'РеквизитыСканерВС')
                    {
                      field.value = '№ ЭФ2204-191237 истекает 03.11.2025';
                    }
                    else if(field.name == 'ИПАдрес')
                    {
                      if(this.parsedData.ip_adress)
                        field.value = this.parsedData.ip_adress;
                    }
                    else if(field.name == 'НомерОтчета')
                    {
                      field.value = uuid.v4()
                    }
                    else if(this.scanovalData.start_at && this.scanovalData.end_at && field.name == 'НачалоИЗавершениеСканирования')
                    {
                      field.value = this.getDateTime(this.scanovalData.start_at) + ' / ' + this.getDateTime(this.scanovalData.end_at)
                    }
                    else if(this.scanovalData.formed_at && field.name == 'ФормированиеОтчета')
                    {
                      field.value = this.getDateTime(this.scanovalData.formed_at)
                    }
                    else if(field.name == 'ДатаОтчёт')
                    {
                      field.value = moment(this.startTime, "DD.MM.YYYY HH:mm:ss").format("DD.MM.YYYY");
                    }
                    else if(field.name == 'ДатаиВремяОтчёт')
                    {
                      let template = this.templates[category_id].filter((item) => item.id == template_id)[0];

                      let last_order = 0;
                      this.categories.forEach(category_group => {
                        this.templates[category_group.id].forEach(template => {
                          if(template.orderKey && template.orderKey > last_order)
                            last_order = parseInt(template.orderKey);
                        });
                      });
                      let minus_minutes = this.randomInteger(30, 55);
                      minus_minutes = parseInt(minus_minutes) * parseInt(last_order) / parseInt(template.orderKey)
                      let full_date = null;
                      let start_date = moment(this.startTime, "DD.MM.YYYY HH:mm:ss").format("DD.MM.YYYY");
                      let start_full_date = this.startTime;
                      let install_date = null;
                      let date = null;

                      let filtered = this.parsedData.programs.filter((program) => {
                        return program.date !== "" && program.version == template.version && program.name.includes(template.po)
                      });
                      if(filtered[0]){
                        filtered = filtered[0];

                        install_date = moment(filtered.date,"YYYY-MM-DD").format("DD.MM.YYYY");
                        date = moment(install_date,"DD.MM.YYYY").format("DD");
                        if(!moment(install_date,"YYYY-MM-DD").isValid()){
                          console.log(filtered)
                        }
                      }

                      if(install_date && start_date !== install_date){
                        full_date = moment(this.startTimeByDate[date],"DD.MM.YYYY HH:mm:ss").subtract(minus_minutes, "minutes").subtract(this.randomInteger(1, 59), "seconds").format("DD.MM.YYYY HH:mm:ss")
                      }else{
                        full_date = moment(start_full_date,"DD.MM.YYYY HH:mm:ss").subtract(minus_minutes, "minutes").subtract(this.randomInteger(1, 59), "seconds").format("DD.MM.YYYY HH:mm:ss");
                      }

                      field.value = full_date;
                      let distr = template_group.filter((item2) => item2.name == 'ДатаиВремяДистр');

                      let distr2 = template_group.filter((item2) => item2.name == 'ДатаиВремяУстановленный');

                      let timeForDistr2 = [this.randomInteger(5, 22), this.randomInteger(1, 59)];
                      let distr3 = template_group.filter((item2) => item2.name == 'ДатаиВремяУстановленный-1 сек');

                      if(distr[0]){
                        distr[0].value = moment(full_date,"DD.MM.YYYY HH:mm:ss").subtract(this.randomInteger(5, 22), "minutes").subtract(this.randomInteger(1, 59), "seconds").format("DD-MM-YYYY HH:mm:ss")
                      }

                      if(distr2[0]){
                        distr2[0].value = moment(full_date,"DD.MM.YYYY HH:mm:ss").subtract(timeForDistr2[0], "minutes").subtract(timeForDistr2[1], "seconds").format("DD-MM-YYYY HH:mm:ss")
                      }

                      if(distr3[0]){
                        distr3[0].value = moment(full_date,"DD.MM.YYYY HH:mm:ss").subtract(timeForDistr2[0], "minutes").subtract(timeForDistr2[1] + 1, "seconds").format("DD-MM-YYYY HH:mm:ss")
                      }
                    }
                  }
                });
              }
            });
          }
        });

        this.isUpdating = false;
      },
      makeString(length) {
        let result = '';
        const characters = 'АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдеёжзийклмнопрстуфхцчшщъыьэюя';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
          counter += 1;
        }
        return result;
      },
      updateProtocolCleaning(){
        if(this.needProtocolCleaning){
          let category_id = this.cleaning_id;
          this.selectedTemplate.fields[category_id].splice(0);
          if(this.templates[category_id])
          {
            let string = this.makeString(6);
            this.templates[category_id].forEach(fields => {
              if(!this.selectedTemplate.fields[category_id][fields.id])
                this.selectedTemplate.fields[category_id][fields.id] = [];
              if(this.selectedTemplate.fields[category_id][fields.id].length > 0)
                this.selectedTemplate.fields[category_id][fields.id].splice(0);
              let temp = [];
              fields.fields.forEach(field => {
                if(!this.defaultFields.filter((item3) => item3.name == field).length){
                  if(field == 'Смещение1')
                    temp.push({name: field, value: this.random1});
                  else if(field == 'Смещение2')
                    temp.push({name: field, value: this.random1 + 117000000});
                  else if(field == 'ПоискСлово')
                    temp.push({name: field, value: string});
                  else if(field == 'ДатаиВремяОтчёт')
                  {
                    if(fields.po.includes('1'))
                    {
                      temp.push({name: field, value: moment(this.startTime,"DD.MM.YYYY HH:mm:ss").subtract(this.randomInteger(4, 10), "minutes").subtract(this.randomInteger(1, 59), "seconds").format("DD.MM.YYYY HH:mm:ss")});
                    }
                    else if(fields.po.includes('2')){
                      temp.push({name: field, value: moment(this.startTime,"DD.MM.YYYY HH:mm:ss").add(this.randomInteger(4, 10), "minutes").add(this.randomInteger(1, 59), "seconds").format("DD.MM.YYYY HH:mm:ss")});
                    }
                  }
                  else
                    temp.push({name: field, value: null});
                }
              });
              this.selectedTemplate.fields[category_id][fields.id] = temp;
            });
          }
        }
      },
      randomDate(date) {
        let hour = this.randomInteger(8, 18);
        let minutes = this.randomInteger(0, 59);
        let seconds = this.randomInteger(0, 59);
        let time = hour + ":" + minutes + ":" + seconds;
        date = date + " " + time
        return moment(date,"DD.MM.YYYY HH:mm:ss").format("DD.MM.YYYY HH:mm:ss")
      },
      randomInteger(min, max){
        return Math.floor(Math.random() * (max - min + 1)) + min;
      },
      createProtocols(){
        this.$Progress.start();
        const data = new FormData();
        let fields = [];
        this.selectedTemplate.fields.forEach((category, category_id) => {
          if(category)
          {
            let temp = []
            category.forEach((template, template_id) => {
              if(template){
                temp.push({template_id: template_id, value: template})
              }
            });
            fields.push({category_id: category_id, value: temp})
          }
        });
        data.append('fields', JSON.stringify(fields));
        data.append('default_fields', JSON.stringify(this.defaultFields));
        axios.post('/api/protocol/create_protocols', data, {responseType: 'arraybuffer'})
        .then((response)=>{
          this.SuccessToast();
          let blob = new Blob([response.data], {
              type: 'application/zip'
          })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'output.zip'
          link.click()
          this.loadRecords();
          this.$Progress.finish();
        })
        .catch((err)=>{
          if(err.response.status == 422) {
            let error = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(err.response.data)));
            let html = '';
            error.errors.forEach(item => {
              html += '<p><b>' + item.template_name + '</b></p><ul style="text-align:left;">';
              item.value.forEach(field => {
                html += '<li>' + field + '</li>';
              });
              html += '</ul>'
            });

            Swal.fire({
              title: error.message,
              html: html,
              confirmButtonText: "Ок",
            });
          }
          this.$Progress.fail();
        })
      },
      changeTab(id){
        this.step = id;
      },
      nextStep(){
        this.step++;
      },
      prevStep(){
        this.step--;
      },
      updateCategory(category_id, template_id){
        this.isUpdating2 = true;
        let last_order = 0;

        if(this.selectedTemplate.checks[category_id])
        {
          this.selectedTemplate.fields[category_id].splice(0);
          if(this.templates[category_id])
          {
            this.selectedTemplate.checks[category_id].forEach((item, i) => {
              if(item){
                let fields = this.templates[category_id].filter((item2) => item2.id == i);
                if(fields[0]){
                  fields = fields[0];
                  if(!fields.orderKey){
                    this.categories.forEach(category_group => {
                      this.templates[category_group.id].forEach(template => {
                        if(template.orderKey && template.orderKey > last_order)
                          last_order = parseInt(template.orderKey);
                      });
                    });
                    last_order = last_order + 1;
                    fields.orderKey = last_order;
                  }
                  if(!this.selectedTemplate.fields[category_id][fields.id])
                    this.selectedTemplate.fields[category_id][fields.id] = [];
                  if(this.selectedTemplate.fields[category_id][fields.id].length > 0)
                    this.selectedTemplate.fields[category_id][fields.id].splice(0);
                  let temp = [];
                  // fields.fields.forEach(field => {
                  //   if(!this.defaultFields.filter((item3) => item3.name == field).length)
                  //     temp.push({name: field, value: null});
                  // });

                  // Если fields пустой, добавляем базовые поля
                  if (fields.fields && fields.fields.length > 0) {
                    // Оригинальные поля из шаблона
                    fields.fields.forEach(field => {
                      if(!this.defaultFields.filter((item3) => item3.name == field).length)
                        temp.push({name: field, value: null});
                    });
                  } else {
                    // Для шаблонов с пустым fields добавляем базовые поля
                    temp = [
                      {name: 'ДатаиВремяОтчёт', value: null},
                    ];
                  }

                  // Автоматически добавляем поле ДатаиВремяОтчёт для всех шаблонов
                  if (!temp.some(item => item.name === 'ДатаиВремяОтчёт')) {
                    temp.push({
                      name: 'ДатаиВремяОтчёт',
                      value: null
                    });
                  }

                  this.selectedTemplate.fields[category_id][fields.id] = temp;
                }
              }else{
                this.templates[category_id].filter((item2) => item2.id == i)[0].orderKey = null;
              }
            });
          }
          this.isUpdating2 = false;
        }

      },
      getTemplateName(category_id, template_id){
        let find = null;
        if(this.templates[category_id])
          find = this.templates[category_id].filter((item2) => item2.id == template_id);

        if(find && find[0])
          return find[0].name;
      },
      checkFilter(){
        if(this.filter == 'skzi'){
          Toast.fire({
            icon: 'error',
            title: 'У вас там всё хорошо?'
          });
          this.hide_skzi = false;
          return false;
        }
      },
      changeFilter(filter){
        this.filter = filter;
        this.hide_skzi = false;
      },
      transform_for_formulary_table() {
        this.hide_skzi = false;
        this.show_conclusion_scsi_table_cryptopro = false;
        this.show_conclusion_scsi_table_vipnet = false;
        this.disableHideScsi = true;
        if(this.show_formulary_table) {
          this.program_table_cols = {
            id: '№ п/п',
            name: 'Название и тип программного средства',
            part_num: 'Серийный номер (номер лицензии)',
            cert_info: 'Сведения о сертификате',
            installation_date: 'Дата установки',
          };
        } else {
          this.disableHideScsi = false;
          this.program_table_cols = {
            id: '#',
            name: 'Наименование',
            version: 'Версия',
            publisher: 'Издатель',
            installation_date: 'Дата установки',
            tags: 'Теги',
          };
        }
      },
      transform_for_conclusion_scsi_table(hide_scsi_type) {
        this.hide_skzi = false;
        this.show_formulary_table = false;
        if(this.show_conclusion_scsi_table_cryptopro || this.show_conclusion_scsi_table_vipnet) {
          if(hide_scsi_type == 'КриптоПро')
            this.show_conclusion_scsi_table_vipnet = false;
          else if(hide_scsi_type == 'ViPNet')
            this.show_conclusion_scsi_table_cryptopro = false;

          this.disableHideScsi = true;
          this.hide_scsi_type = hide_scsi_type;
          this.program_table_cols = {
            id: '№ п/п',
            name: 'Название и тип программного средства',
            part_num: 'Серийный номер (номер лицензии)',
          };
        } else {
          this.disableHideScsi = false;
          this.program_table_cols = {
            id: '#',
            name: 'Наименование',
            version: 'Версия',
            publisher: 'Издатель',
            installation_date: 'Дата установки',
            tags: 'Теги',
          };
        }
      },
      getDateTime(date_time){
        return moment.utc(date_time).format("DD.MM.YYYY HH:mm:ss");
      },
      getDate(date){
        const formats = ['DD.MM.YYYY', 'DD.MM.YY', 'YYYY-MM-DD'];
        const newDate = moment(date, formats, true);

        if(!newDate.isValid()){
            return '-';
        }
        return newDate.format("DD.MM.YYYY");
      },
      fileUpload(e){
        this.dvd_letter = null;
        this.parsedData.computer_name = null;
        this.parsedData.computer_manufacture = null;
        this.parsedData.computer_sn = null;
        this.parsedData.computer_system = null;
        this.parsedData.computer_system_version = null;
        this.parsedData.optical_reader = null;
        this.parsedData.created_at = null;
        this.parsedData.human_build = null;
        this.parsedData.human_os = null;
        this.parsedData.ip_adress = null;
        this.parsedData.mac_adress = null;
        this.parsedData.windows_build = null;
        this.parsedData.windows_install = null;
        this.parsedData.printers.splice(0);
        this.parsedData.programs.splice(0);
        this.parsedData.users.splice(0);
        this.parsedData.licenses.splice(0);
        this.parsedData.disks.splice(0);
        const data = new FormData();
        data.append('file', e.target.files[0]);
        axios.post('/api/protocol/aida_file', data)
        .then((response)=>{
          this.parsedData = response.data;
          this.fileInputKey++;
          if(!this.scanovalData.end_at || this.scanovalData.end_at && moment.utc(response.data.created_at) > moment.utc(this.scanovalData.end_at))
            this.startTime = moment.utc(response.data.created_at).format("DD.MM.YYYY HH:mm:ss");

          this.categories.forEach(item => {
            if(item.name !== "Протоколы стирания")
              this.selectedTemplate.checks[item.id].splice(0);
          });

          let skzi_programs = response.data.programs.filter((item) => item.type == 'skzi');
          let szi_programs = response.data.programs.filter((item) => item.type == 'szi');
          if(skzi_programs && skzi_programs.length > 0)
          {
            let skzi_id = this.categories.filter((item) => item.name == 'СКЗИ')[0].id;
            this.setFieldsFromProgramList(skzi_programs, skzi_id);
          }

          if(szi_programs && szi_programs.length > 0)
          {
            let szi_id = this.categories.filter((item) => item.name == 'СЗИ')[0].id;
            this.setFieldsFromProgramList(szi_programs, szi_id);
          }
          this.$Progress.finish();
        })
        .catch(()=>{
          this.ErrorToast();
          this.$Progress.fail();
        })
      },
      setFieldsFromProgramList(list, id){
        let last_order = 0;
        let start_date = moment(this.startTime, "DD.MM.YYYY HH:mm:ss").format("DD.MM.YYYY");

        list.forEach(item => {
          if(this.templates[id]){
            this.templates[id].forEach((item2, i) => {
              if(item.name == item2.po && item.version == item2.version){
                this.selectedTemplate.checks[id][item2.id] = true;

                this.categories.forEach(category_group => {
                  this.templates[category_group.id].forEach(template => {
                    if(template.orderKey && template.orderKey > last_order)
                      last_order = parseInt(template.orderKey);
                  });
                });
                last_order = last_order + 1;
                item2.orderKey = last_order;

                if(item.date){
                  let install_date = moment(item.date,"YYYY-MM-DD").format("DD.MM.YYYY");
                  if(install_date !== this.startTime)
                    var full_date = this.randomDate(install_date);
                    var date = moment(full_date,"DD.MM.YYYY").format("DD");
                    if(!this.startTimeByDate[date])
                      this.startTimeByDate[date] = full_date;
                }

                if(!this.selectedTemplate.fields[id][item2.id])
                  this.selectedTemplate.fields[id][item2.id] = [];
                let temp = [];
                // item2.fields.forEach(field => {
                //   if(!this.defaultFields.filter((item3) => item3.name == field).length){
                //     temp.push({name: field, value: null});
                //
                //   }
                // });

                // Если fields пустой, добавляем базовые поля
                if (item2.fields && item2.fields.length > 0) {
                  // Оригинальные поля из шаблона
                  item2.fields.forEach(field => {
                    if(!this.defaultFields.filter((item3) => item3.name == field).length)
                      temp.push({name: field, value: null});
                  });
                } else {
                  // Для шаблонов с пустым fields добавляем базовые поля
                  temp = [
                    {name: 'ДатаиВремяОтчёт', value: null},
                  ];
                }

                // Всегда добавляем ДатаиВремяОтчёт если его нет
                if (!temp.some(fieldItem => fieldItem.name === 'ДатаиВремяОтчёт')) {
                  temp.push({
                    name: 'ДатаиВремяОтчёт',
                    value: null
                  });
                }

                this.selectedTemplate.fields[id][item2.id] = temp;
              }
            });
          }
        });
      },
      fileUploadS(e){
        this.scanovalData.number = null;
        this.scanovalData.start_at = null;
        this.scanovalData.end_at = null;
        this.scanovalData.formed_at = null;
        this.scanovalData.vulnerabilities.splice(0);
        const data = new FormData();
        data.append('file', e.target.files[0]);
        axios.post('/api/protocol/scanoval_file', data)
        .then((response)=>{
          this.scanovalData = response.data;
          this.fileInputKeyS++;
          if(!this.parsedData.created_at || this.parsedData.created_at && moment.utc(response.data.formed_at) > moment.utc(this.parsedData.created_at))
            this.startTime = moment.utc(response.data.formed_at).format("DD.MM.YYYY HH:mm:ss");
          let category = this.categories.filter((item) => item.name === 'Другие СЗИ');
          let last_order = 0;
          if(category && category[0] && this.templates[category[0].id]){
            let template = this.templates[category[0].id].filter((item) => item.po === 'RedCheck');
            if(template && template[0]){
              let template_id = template[0].id;
              let category_id = category[0].id;

              this.selectedTemplate.checks[category_id][template_id] = true;

              this.categories.forEach(category_group => {
                this.templates[category_group.id].forEach(template => {
                  if(template.orderKey && template.orderKey > last_order)
                    last_order = parseInt(template.orderKey);
                });
              });
              last_order = last_order + 1;
              template[0].orderKey = last_order;

              this.selectedTemplate.fields[category_id].splice(0);

              if(!this.selectedTemplate.fields[category_id][template_id])
                this.selectedTemplate.fields[category_id][template_id] = [];
              if(this.selectedTemplate.fields[category_id][template_id].length > 0)
                this.selectedTemplate.fields[category_id][template_id].splice(0);
              let temp = [];
              let ip_adress = this.parsedData.ip_adress;
              template[0].fields.forEach(field => {
                if(!this.defaultFields.filter((item3) => item3.name == field).length){
                  if(field == 'НомерОтчета')
                    temp.push({name: field, value: response.data.number});
                  else if(field == 'НачалоИЗавершениеСканирования')
                    temp.push({name: field, value: moment.utc(response.data.start_at).format("DD.MM.YYYY HH:mm:ss") + ' / ' + moment.utc(response.data.end_at).format("DD.MM.YYYY HH:mm:ss")});
                  else if(field == 'ФормированиеОтчета')
                    temp.push({name: field, value: moment.utc(response.data.formed_at).format("DD.MM.YYYY HH:mm:ss")});
                  else if(field == 'ИПАдрес')
                    temp.push({name: field, value: ip_adress});
                  else
                    temp.push({name: field, value: null});
                }
              });
              this.selectedTemplate.fields[category_id][template_id] = temp;
            }
          }
          this.$Progress.finish();
        })
        .catch(()=>{
          this.ErrorToast();
          this.$Progress.fail();
        })
      },
      SuccessToast(){
        Toast.fire({
          icon: 'success',
          title: 'Успешно'
        });
      },
      ErrorToast(){
        Toast.fire({
          icon: 'error',
          title: 'Ошибка'
        });
      },
      loadCategories(){
        axios.get('/api/protocol/template_category').then(({ data }) => {
          let output = [];
          data.forEach((item, i) => {
            this.selectedTemplate.checks[item.id] = [];
            this.selectedTemplate.fields[item.id] = [];
            if(item.name == 'Протоколы стирания'){
              this.cleaning_id = item.id;
            }
            else{
              output[i] = item;
            }
          });
          this.categories = output;
          this.loadTemplates();
        });
      },
      loadTemplates(){
        axios.get('/api/protocol/templates_for_work').then(({ data }) => {
          this.templates = data;
        });
      }
    },
    created() {
      this.$Progress.start();
      this.loadCategories();
      this.random1 = this.randomInteger(5000000000 * 5, 1000000000 * 60);
      this.startTime = moment().format("DD.MM.YYYY HH:mm:ss");
      this.$Progress.finish();
    }
  }
</script>
